import { PaymentFrequency } from '@customTypes/types';
import { useIntl } from 'react-intl';

export const usePaymentFrequencyList = () => {
  const { formatMessage } = useIntl();

  return Object.entries(PaymentFrequency).map(([key, value]) => ({
    value,
    label: formatMessage({ id: `commons.paymentFrequency.${key}` })
  }));
};
